export * from '../ViewletLocations/ViewletLocations.js'

export const name = 'References'
